import apiProvider from './provider';
import {
  FETCH_ACCOUNT_DETAILS,
  UPDATE_ACCOUNT_DETAILS,
  CHANGE_PASSWORD,
  GENERATE_API_KEY,
  ACCEPT_PRIVACY_POLICY,
  FETCH_SSL_CERTIFICATE_DETAILS,
} from './routes';
import { getAuthenticationHeaders, getErrorMessage, getOrgPrettyName } from './utils';
import { API_BASE_URL } from 'src/globals';
import { PATCH, ApiResponseWrapper } from './apiHandler';
import { AxiosResponse } from 'axios';



export const fetchAccountDetails = async () => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.post(
      API_BASE_URL + FETCH_ACCOUNT_DETAILS,
      {},
      {
        headers: Object.assign({ 'organisation-pretty-name': getOrgPrettyName() },
          getAuthenticationHeaders(),
        ),
      },
    );
    return {
      data: response.data.data,
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const fetchCertificateDetails = async () => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(
      `${API_BASE_URL}${FETCH_SSL_CERTIFICATE_DETAILS}`, {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response?.data?.data,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const updateAccountDetails = async (body) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + UPDATE_ACCOUNT_DETAILS, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data,
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const changePassword = async (body) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + CHANGE_PASSWORD, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data,
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const generateApiKey = async () => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + GENERATE_API_KEY, {},
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const acceptPrivacyAgreement = () => {
  return PATCH(`${API_BASE_URL}${ACCEPT_PRIVACY_POLICY}`, {});
};
